import { isElectron } from '@/utils/platformUtils';

/** When set from `<Router>`, `navigateTo` uses client navigation instead of `location.href`. */
type SpaNavigate = (to: string, options?: { replace?: boolean }) => void;
let spaNavigate: SpaNavigate | null = null;

export function registerSpaNavigator(fn: SpaNavigate | null): void {
  spaNavigate = fn;
}

export const isAtFastSwitchPath = (): boolean => {
  if (typeof window === 'undefined') return false;
  if (isElectron()) {
    const path = window.location.hash.replace(/^#/, '').split('?')[0] || '';
    return path === '/fast-switch' || path.startsWith('/fast-switch/');
  }
  return window.location.pathname === '/fast-switch' || window.location.pathname.startsWith('/fast-switch/');
};

export const navigateTo = (path: string): void => {
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;

  if (isElectron()) {
    //routing for Electron (file:// protocol)
    window.location.hash = `#/${cleanPath}`;
    return;
  }

  const hrefPath = path.startsWith('/') ? path : `/${cleanPath}`;
  if (spaNavigate) {
    spaNavigate(hrefPath, { replace: true });
    return;
  }
  window.setTimeout(() => {
    if (spaNavigate) {
      spaNavigate(hrefPath, { replace: true });
    } else {
      window.location.href = hrefPath;
    }
  }, 0);
};

export const navigateToAuth = (): void => {
  navigateTo('/auth');
};
